import { DEFAULT_USER_STATUS_COLOR_MODE, USER_LANGUAGE_SETTINGS, USER_STATUS_COLOR_MODES } from 'cpool-constants';
import { z } from 'zod';

export const schemaUserLanguageSetting = z.nativeEnum(USER_LANGUAGE_SETTINGS);

export const schemaUserStatusColorMode = z.nativeEnum(USER_STATUS_COLOR_MODES);

// new fields need a .default(), rows stored before them lack the key
export const schemaUserSettings = z.object({
    language: schemaUserLanguageSetting,
    statusColorMode: schemaUserStatusColorMode.default(DEFAULT_USER_STATUS_COLOR_MODE),
});

export type Schema_UserSettings = z.infer<typeof schemaUserSettings>;

/**
 * What a "change personal settings" command/event carries: a partial patch of `schemaUserSettings`,
 * with each field directly at the top level — only the field(s) actually being changed, so adding a
 * new preference never requires touching this schema.
 */
export const schemaUser_ChangePersonalSettings = schemaUserSettings.partial();

export type Schema_User_ChangePersonalSettings = z.infer<typeof schemaUser_ChangePersonalSettings>;
